import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, InfinityIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { PRODUCT_IMAGE } from '../data/content';
const trustItems = [{
  icon: ZapIcon,
  label: 'Instant digital access'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="w-full bg-navy-950 pb-10 pt-8 sm:pb-14 sm:pt-12" data-id="element-211" data-mp="za2avlq48229">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-212" data-mp="zc6myqy647dm">
        <p className="mx-auto max-w-[28ch] text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300 sm:max-w-none sm:text-[12.5px]" data-id="element-213" data-mp="v9ie4j9gf0gn">
          The Aligner Planning Master System™

        </p>

        <h1 className="mx-auto mt-4 max-w-3xl text-center font-display text-[30px] font-black leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[56px]" data-id="element-214" data-mp="2plzsf1cbeq95">
          Stop Guessing. Start Planning Aligner Cases{' '}
          <span className="text-brand-300" data-id="element-215" data-mp="mcgn9sg9sanb">Like an Expert.</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-brand-100 sm:text-lg" data-id="element-216" data-mp="rb08trqybkf5">
          Learn exactly what to review at every stage of treatment to reduce avoidable
          refinements, prevent planning mistakes, and approach your cases with greater
          confidence and predictability.
        </p>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-10" data-id="element-217" data-mp="19zx1jr6pa4v9">
          <div className="order-1 lg:order-2" data-id="element-218" data-mp="w8jn2rnnfx73">
            <img src={PRODUCT_IMAGE} alt="The Aligner Planning Master System — six clinical volumes shown on desktop, tablet and mobile devices" className="mx-auto w-full max-w-[560px]" width={1080} height={1080} data-id="element-219" data-mp="w7qoidyuge01" />
          </div>

          <div className="order-2 lg:order-1" data-id="element-220" data-mp="1tpgxi11ovilv">
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6" data-id="element-221" data-mp="23jmkl98zp6p1">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-brand-300" data-id="element-222" data-mp="1yktew2zy2jzf">
                The Aligner Planning Master System™
              </p>
              <p className="mt-2.5 text-[15px] leading-relaxed text-white sm:text-base" data-id="element-223" data-mp="1tjvox48p0lnd">
                A complete clinical library featuring{' '}
                <strong className="font-bold" data-id="element-224" data-mp="1klk119z7o1ym">6 specialized volumes</strong> +{' '}
                <strong className="font-bold" data-id="element-225" data-mp="1fubs0f1smilz">5 exclusive bonuses</strong> designed to help
                you plan, review, execute, and finish clear aligner cases with a structured
                clinical system.
              </p>

              <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-226" data-mp="15x72q6cni70y">
                {trustItems.map(item => <li key={item.label} className="flex items-center gap-2" data-id="element-227" data-mp="10wjefsft44af">
                    <item.icon aria-hidden="true" className="h-4 w-4 shrink-0 text-brand-300" data-id="element-228" data-mp="wwimd4zsbukw" />
                    <span className="text-[13px] font-semibold text-brand-100" data-id="element-229" data-mp="38jkumsupm1lw">
                      {item.label}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-6" data-id="element-230" data-mp="3hkiynb55e94h">
                <CtaButton id="cta-hero" label="Get instant access — $27" sub="Currency converts automatically to your local currency." size="lg" data-id="element-231" data-mp="3hhem9qhj472q" />
              </div>

              <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-[12px] font-medium text-brand-100" data-id="element-232" data-mp="2tt589aqk4nm5">
                <CheckIcon aria-hidden="true" className="h-4 w-4 text-emerald-400" data-id="element-233" data-mp="2yrf3tmg71q8a" />
                Used by clinicians in more than 20 countries
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
}